import script from "./TabsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabsView.vue?vue&type=script&setup=true&lang=ts"

import "./TabsView.vue?vue&type=style&index=0&id=7b494c8d&scoped=true&lang=scss"

import exportComponent from "/home/deployer/pwa/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b494c8d"]])

export default __exports__